<script lang="ts">
	import { Icon, Text, type StatsPropsTypes } from '@Shelly/shelly-design-system';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	import { buildRawStatusIcon } from 'src/components/GenericStatusesIcons/statusListBuilder';
	import MqttIcon from 'src/components/GenericStatusesIcons/MqttIcon.svelte';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { real_id } from 'src/helpers/interface_helpers';
	import { btHomeRemoteIcon } from 'src/stores/features/ble/bt-home-remote-icon';

	export let device, status, settings;

	$: deviceRealId = device?.id ? real_id(device.id) : undefined;
	$: rawIconList = buildRawStatusIcon(device, status, settings, 'card', {
		hasPairedRemotesHint: deviceRealId ? $btHomeRemoteIcon[deviceRealId] : undefined,
	});
	$: statsList = rawIconList.map((item) => ({
		icon: item.icon,
		text: item?.text,
		active: !!item?.active,
		iconColor: item?.iconColor,
	})) as StatsPropsTypes[];
</script>

<div
	class={classMap({
		'device-status-bar': true,
		'new-layout': $showNewLayout,
	})}
>
	{#each statsList as icon}
		{#if icon.icon !== 'mqtt'}
			<Icon
				icon={icon.icon}
				class={`${icon.iconColor ? `text-${icon.iconColor}` : classMap({ 'text-color-3': !icon.active })} mr-${icon?.text ? 'xxs' : 'xs'}`}
				size="xxs"
			/>
			{#if icon.text}
				<Text class="miniature-styles mr-xs">{icon.text}</Text>
			{/if}
		{:else}
			<!-- this is needed because font awesome doesn't have that icon -->
			<MqttIcon active={icon.active} size={10} className="ml-xxs" />
		{/if}
	{/each}
</div>

<style>
	.device-status-bar {
		background: var(--color-1);
		display: flex;
		scrollbar-width: none;
		flex-direction: row;
		align-items: center;
		padding: 2px 6px;
	}

	.device-status-bar.new-layout {
		background-color: var(--color-base);
	}
</style>
